<template>
  <div v-loading="loading" v-if="tableData.length" class="day-income-table" v-uac="'dashboard.dayincome'" data-uac="dashboard.dayincome$$首页.日销售额统计">
    <div class="header" style="margin-bottom: 6px;">
      {{ spanShow }}&nbsp; &nbsp;日销售额明细
      <el-radio-group v-model="showMode" style="margin-left: 10px;">
        <el-radio v-model="showMode" label="3">同时显示</el-radio>
        <el-radio v-model="showMode" label="1">仅显示EPC</el-radio>
        <el-radio v-model="showMode" label="2">仅显示订单</el-radio>
      </el-radio-group>
      <el-select v-if="showMode === '2'" v-model="orderBrand" size="mini" style="width: 100px; margin-left: 10px;">
        <el-option v-for="serie in brandSeries" :key="serie.serieName" :label="serie.serieName" :value="serie.serieName"></el-option>
      </el-select>
    </div>
    <div class="context">
      <el-table :data="tableData" @sort-change="doSort" ref="dataTable">
        <el-table-column prop="area" property="area" label="区域" fixed sortable="custom" width="80"></el-table-column>
        <el-table-column v-for="day in days" :prop="day.format('YYYY-MM-DD')" :key="day.format('YYYY-MM-DD')" :label="`${day.format('MM-DD')}(${['周日', '周一', '周二', '周三', '周四', '周五', '周六'][day.weekday()]})`">
          <el-table-column v-if="showMode === '1' || showMode === '3'" prop="epcAmount" label="EPC" width="88">
            <template slot-scope="scope">
              <div class="cell" v-if="scope.row[day.format('YYYY-MM-DD')]" style="text-align: right;">
                {{ (scope.row[day.format('YYYY-MM-DD')] && scope.row[day.format('YYYY-MM-DD')].epcAmount || 0).toFixed(2) }}
              </div>
              <div v-else style="text-align: right;">--</div>
            </template>
          </el-table-column>
          <el-table-column v-if="showMode === '2' || showMode === '3'" prop="orderAmount" label="订单" width="88">
            <template slot-scope="scope">
              <div class="cell" v-if="scope.row[day.format('YYYY-MM-DD')]" style="text-align: right;">
                {{ scope.row[day.format('YYYY-MM-DD')].brandsDatas.filter(t => orderBrandFilter(t)).reduce((p, c) => p + c.orderAmount - c.returnAmount, 0) | wanFmt }}
              </div>
              <div v-else style="text-align: right;">--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-if="showMode === '1'" fixed="right" key="monthTotal.epconly" prop="monthTotal" property="monthTotal" label="合计" width="100">
          <el-table-column prop="monthTotal.epcAmount" label="EPC" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.monthTotal" class="cell" style="text-align: right;">
                {{ (scope.row.monthTotal && scope.row.monthTotal.epcAmount || 0) | wanFmt }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-else-if="showMode === '2'" fixed="right" key="monthTotal.orderonly" prop="monthTotal" property="monthTotal" label="合计" width="100">
          <el-table-column prop="monthTotal.orderAmount" label="订单" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.monthTotal" class="cell" style="text-align: right;">
                {{ scope.row.monthTotal.brandsDatas.filter(t => orderBrandFilter(t)).reduce((p, c) => p + c.orderAmount - c.returnAmount, 0) | wanFmt }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-else fixed="right" prop="monthTotal" key="monthTotal.showall" property="monthTotal" label="合计" width="200">
          <el-table-column prop="monthTotal.epcAmount" label="EPC" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.monthTotal" class="cell" style="text-align: right;">
                {{ (scope.row.monthTotal && scope.row.monthTotal.epcAmount || 0) | wanFmt }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column prop="monthTotal.orderAmount" label="订单" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.monthTotal" class="cell" style="text-align: right;">
                {{ scope.row.monthTotal.brandsDatas.filter(t => orderBrandFilter(t)).reduce((p, c) => p + c.orderAmount - c.returnAmount, 0) | wanFmt }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { queryDayIncomeData } from '../services'
const _cacheData = new Map()

export default {
  props: {
    month: {
      type: String,
      required: true,
      default () {
        return moment().format('YYYY-MM-01')
      }
    },
    spanType: {
      type: String,
      required: true,
      default () {
        return 'month'
      }
    }
  },
  filters: {
    wanFmt (val) {
      if (Math.abs(+val) > 100) {
        let numberStr = (+val / 10000).toFixed(2)
        if (numberStr.endsWith('.00')) {
          numberStr = numberStr.substring(0, numberStr.length - 3)
        }
        return numberStr + '万'
      } else {
        return val
      }
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      showMode: '3',
      orderBrand: '全部',
      brandSeries: [
        {
          serieName: '全部',
          filterFunc: () => true
        },
        {
          serieName: '奔驰系',
          filterFunc: (item) => ~['benz', 'smart', 'maybach'].indexOf(item.brandCode)
        },
        {
          serieName: '宝马系',
          filterFunc: (item) => ~['bmw', 'mini', 'rolls_royce'].indexOf(item.brandCode)
        },
        {
          serieName: '捷豹路虎',
          filterFunc: (item) => ~['landrover', 'jaguar'].indexOf(item.brandCode)
        },
        {
          serieName: '大众系',
          filterFunc: (item) => ~['vw', 'audi', 'porsche'].indexOf(item.brandCode)
        },
        {
          serieName: '其他',
          filterFunc: (item) => [
            'benz',
            'smart',
            'maybach',
            'bmw',
            'mini',
            'rolls_royce',
            'landrover',
            'jaguar',
            'vw',
            'audi',
            'porsche'
          ].indexOf(item.brandCode) === -1
        }
      ]
    }
  },
  computed: {
    monthStart () {
      return moment(this.month)
    },
    monthEnd () {
      return moment(this.month).add(this.spanType === 'month' ? 1 : 3, 'months')
    },
    days () {
      var days = []
      for (var i = moment(this.month); i.isBefore(this.monthEnd); i = i.add(1, 'day')) {
        days.push(moment(i.format('YYYY-MM-DD')))
      }
      return days
    },
    orderBrandFilter () {
      return this.brandSeries.find(t => t.serieName === this.orderBrand).filterFunc
    },
    spanShow () {
      return this.spanType === 'month' ? moment(this.month).format('YYYY-MM') : moment(this.month).format('YYYY-[Q]Q')
    }
  },
  watch: {
    spanShow: {
      immediate: true,
      handler () {
        this.loadMonthData()
      }
    },
    area: {
      immediate: false,
      handler () {
        this.loadMonthData()
      }
    },
    showMode (_newVal, oldVal) {
      if (oldVal === '2') {
        this.orderBrand = '全部'
      }
      this.$nextTick(() => {
        this.$refs.dataTable.doLayout()
        this.checkScroll()
      })
    }
  },
  mounted () {
    this.loadMonthData()
  },
  methods: {
    doSort (col) {
      if (col.order === null) {
        return
      }
      const sortedData = this.tableData.slice(0, this.tableData.length - 1)
      sortedData.sort((a, b) => {
        if (col.prop === 'area') {
          if (col.order === 'ascending') {
            return a.area.localeCompare(b.area)
          } else if (col.order === 'descending') {
            return b.area.localeCompare(a.area)
          }
        }
        if (col.order === 'ascending') {
          return a[col.prop].totalAmount - b[col.prop].totalAmount
        } else if (col.order === 'descending') {
          return b[col.prop].totalAmount - a[col.prop].totalAmount
        }
      })
      this.tableData.splice(0, this.tableData.length - 1, ...sortedData)
    },
    checkScroll () {
      this.$nextTick(() => {
        const tableAreaEl = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper')
        if (this.spanShow === moment().format(this.spanType === 'month' ? 'YYYY-MM' : 'YYYY-[Q]Q')) {
          const nowDate = moment().diff(this.monthStart, 'days') + 1
          const nowDateLeft = nowDate * 88 * (this.showMode === '3' ? 2 : 1) + 80 + (this.showMode === '3' ? 200 : 100)
          if (nowDateLeft > tableAreaEl.clientWidth) {
            tableAreaEl.scrollLeft = nowDateLeft - tableAreaEl.clientWidth
          } else {
            tableAreaEl.scrollLeft = 0
          }
        } else {
          tableAreaEl.scrollLeft = 0
        }
      })
    },
    loadMonthData () {
      this.loading = true
      const queryMonth = this.month
      queryDayIncomeData({
        startDay: this.monthStart.format('YYYY-MM-DD'),
        endDay: this.monthEnd.format('YYYY-MM-DD'),
        area: this.area
      }).then((res) => {
        const areas = Array.from(new Set(res.map(t => t.area)))
        const rowTotal = {
          area: '合计',
          monthTotal: {
            epcAmount: 0,
            orderAmount: 0,
            returnAmount: 0,
            totalAmount: 0,
            brandsDatas: []
          }
        }
        const result = areas.map(area => {
          const row = {
            area,
            monthTotal: {
              epcAmount: 0,
              orderAmount: 0,
              returnAmount: 0,
              totalAmount: 0,
              brandsDatas: []
            }
          }
          this.days.forEach(day => {
            const cellData = res.find(t => t.area === area && t.day === day.format('YYYY-MM-DD'))
            if (cellData) {
              row[day.format('YYYY-MM-DD')] = cellData
              row.monthTotal.brandsDatas.push(...cellData.brandsDatas)
              row.monthTotal.epcAmount += cellData.epcAmount
              row.monthTotal.orderAmount += cellData.orderAmount
              row.monthTotal.returnAmount += cellData.returnAmount
              row.monthTotal.totalAmount += cellData.totalAmount
              if (!rowTotal[day.format('YYYY-MM-DD')]) {
                rowTotal[day.format('YYYY-MM-DD')] = {
                  epcAmount: cellData.epcAmount,
                  orderAmount: cellData.orderAmount,
                  returnAmount: cellData.returnAmount,
                  totalAmount: cellData.totalAmount,
                  brandsDatas: cellData.brandsDatas
                }
              } else {
                rowTotal[day.format('YYYY-MM-DD')].epcAmount += cellData.epcAmount
                rowTotal[day.format('YYYY-MM-DD')].orderAmount += cellData.orderAmount
                rowTotal[day.format('YYYY-MM-DD')].returnAmount += cellData.returnAmount
                rowTotal[day.format('YYYY-MM-DD')].totalAmount += cellData.totalAmount
                rowTotal[day.format('YYYY-MM-DD')].brandsDatas.push(...cellData.brandsDatas)
              }
              rowTotal.monthTotal.brandsDatas.push(...cellData.brandsDatas)
              rowTotal.monthTotal.epcAmount += cellData.epcAmount
              rowTotal.monthTotal.orderAmount += cellData.orderAmount
              rowTotal.monthTotal.returnAmount += cellData.returnAmount
              rowTotal.monthTotal.totalAmount += cellData.totalAmount
            }
          })
          return row
        })
        result.push(rowTotal)
        _cacheData.set(queryMonth + this.area, result)
        this.tableData = result
        this.doSort({
          prop: 'area',
          order: 'ascending'
        })
        this.checkScroll()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.day-income-table
  margin-top 10px
  background #fff
  border-radius: 4px
  padding: 10px
  min-width 1024px
  .header
    text-align: center
    font-size: 16px
    font-weight: bold
  .el-table--border .el-table__cell,
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left~.el-table__fixed
    border-right-color: #e5e5e5
  .el-table
    td, th
      border-color: #e5e5e5
    thead.is-group
      th.el-table__cell
        background: #f2f2f2;
        border-bottom-color: #e5e5e5
        border-right-color: #e5e5e5
    .el-table__header
      .cell
        padding 0 4px
        color #111111
        text-align: center !important
    .el-table__cell
      padding: 4px 0
      border-bottom-color: #e5e5e5
      border-right-color: #e5e5e5
      .cell
        text-align center
        line-height 1.2
        font-weight normal
        padding 0 4px
        &.health
          color: #52C41B;
          .percent
            color: #52C41B;
        &.danger
          color: #FF4D4F;
          .percent
            color: #FF4D4F;
        .el-button--text
          position absolute
        .percent
          color #9c9c9c
          font-size 12px
</style>
